var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSadd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mi:add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 2C6.13261 2 6.25979 2.05268 6.35355 2.14645C6.44732 2.24021 6.5 2.36739 6.5 2.5V5.5H9.5C9.63261 5.5 9.75979 5.55268 9.85355 5.64645C9.94732 5.74021 10 5.86739 10 6C10 6.13261 9.94732 6.25979 9.85355 6.35355C9.75979 6.44732 9.63261 6.5 9.5 6.5H6.5V9.5C6.5 9.63261 6.44732 9.75979 6.35355 9.85355C6.25979 9.94732 6.13261 10 6 10C5.86739 10 5.74021 9.94732 5.64645 9.85355C5.55268 9.75979 5.5 9.63261 5.5 9.5V6.5H2.5C2.36739 6.5 2.24021 6.44732 2.14645 6.35355C2.05268 6.25979 2 6.13261 2 6C2 5.86739 2.05268 5.74021 2.14645 5.64645C2.24021 5.55268 2.36739 5.5 2.5 5.5H5.5V2.5C5.5 2.36739 5.55268 2.24021 5.64645 2.14645C5.74021 2.05268 5.86739 2 6 2Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadd);
export default __webpack_public_path__ + "static/media/sadd.2a640b4ad4517bde939a6c8d5eb47add.svg";
export { ForwardRef as ReactComponent };